import { useEffect, useState } from 'react';

type Anchor = 'top' | 'bottom' | 'left' | 'right';

export const useElementOffset = (selector: string, anchor: Anchor = 'bottom') => {
	const [offset, setOffset] = useState(0);

	useEffect(() => {
		const el = document.querySelector(selector) as HTMLElement | null;
		if (!el) return;

		const measure = () => {
			const rect = el.getBoundingClientRect();
			const value =
				anchor === 'top'
					? rect.top
					: anchor === 'bottom'
					? rect.bottom
					: anchor === 'left'
					? rect.left
					: rect.right;
			setOffset(value);
		};

		// Observers y listeners
		const io = new IntersectionObserver(measure, {
			root: null,
			threshold: [0, 0.01, 0.5, 1],
		});
		io.observe(el);

		const ro = new ResizeObserver(measure);
		ro.observe(el);

		const mo = new MutationObserver(() => measure());
		mo.observe(document.body, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['class', 'style'],
		});

		window.addEventListener('scroll', measure, { passive: true });
		window.addEventListener('resize', measure);

		measure(); // inicial

		return () => {
			io.disconnect();
			ro.disconnect();
			mo.disconnect();
			window.removeEventListener('scroll', measure);
			window.removeEventListener('resize', measure);
		};
	}, [selector, anchor]);

	return offset;
};
